import moment from 'moment';

export const usePlan = () => {
  const isUserPlanExpired = (user) => {
    if (!user || !user.plan) return false;
    const { expiration } = user.plan;
    const result = moment().isAfter(moment.unix(expiration));
    return result;
  };

  const getPlanType = (user) => {
    if (!user) return PLAN.guest;
    if (user.guest) return PLAN.guest;
    if (isUserPlanExpired(user)) return PLAN.expired;
    return user.plan && user.plan.id;
  };

  return { getPlanType };
};

export const PLAN = {
  enterprise: 'enterprise',
  single_creator: 'single_creator',
  business_monthly: 'business_monthly',
  premium_monthly: 'premium_monthly',
  trial: 'trial',
  expired: 'expired',
  participant: 'participant',
  guest: 'guest',
};
